import axios from "axios/index";
import {root} from "../redux/api.config";
import {ListRequest} from "../models/request";
import {authHeader} from "../helpers/AuthHeader";

const resource = 'user';

export default class UserAPI {

    static getList(params: ListRequest) {
        const options = {
            url: `${root}/api/${resource}`,
            method: 'get',
            headers: authHeader(),
            params: params
        };
        return axios(options).then(response => ({response}))
            .catch(error => ({error}));
    }

    static getOne(id) {
        const options = {
            url: `${root}/api/${resource}/${id}`,
            method: 'get',
            headers: authHeader(),
        };
        return axios(options).then(response => ({response}))
            .catch(error => ({error}));
    }

    static create(data) {
        const options = {
            url: `${root}/api/${resource}`,
            method: 'post',
            headers: {
                ...authHeader(),
                'Content-Type': 'application/json'
            },
            data: data
        };
        return axios(options).then(response => ({response}))
            .catch(error => ({error}));
    }

    static update(id, data) {
        const options = {
            url: `${root}/api/${resource}/${id}`,
            method: 'put',
            headers: {
                ...authHeader(),
                'Content-Type': 'application/json'
            },
            data: data
        };
        return axios(options).then(response => ({response}))
            .catch(error => ({error}));
    }

    static delete(id) {
        const options = {
            url: `${root}/api/${resource}/${id}`,
            method: 'delete',
            headers: authHeader(),
        };
        return axios(options).then(response => ({response}))
            .catch(error => ({error}));
    }

    static importPicture(userId, fbId) {
        const options = {
            url: `${root}/api/fb/picture`,
            method: 'get',
            headers: {
                ...authHeader(),
                'Content-Type': 'application/json'
            },
            params: {user: userId, fb: fbId}
        };
        return axios(options).then(response => ({response}))
            .catch(error => ({error}));
    }

    static importId(userId, fbName) {
        const options = {
            url: `${root}/api/fb/id`,
            method: 'get',
            headers: {
                ...authHeader(),
                'Content-Type': 'application/json'
            },
            params: {user: userId, fb: fbName}
        };
        return axios(options).then(response => ({response}))
            .catch(error => ({error}));
    }


}